<template>
  <div>
    <v-select
      v-if="showSelectCondition"
      class="select_reason"
      :options="rejectionReasons"
      :placeholder="reasonPlaceholder"
      :clearable="false"
      :searchable="false"
      label="translated"
      @input="changeReason"
    />
    <textarea
      class="input-textarea mk__area"
      :placeholder="commentPlaceholder ? commentPlaceholder : $t('mc.placeholders.comment')"
      v-model="comment"
      @input="changeComment"
    />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        comment: ''
      }
    },
    props: {
      commentPlaceholder: {
        type: String,
        required: false
      },
      reasonPlaceholder:{
        type: String,
        required: false
      },
      rejectionReasons: {
        type: Array,
        required: true
      },
      showSelectCondition: {
        type: Boolean,
        default: true,
        required: false
      }
    },
    beforeDestroy() {
      this.$emit('toggleTriggerSaveButtonToDisable', true)
    },
    methods: {
      changeReason(rejectionReason) {
        this.$emit('changeReason', rejectionReason)
      },
      changeComment() {
        this.$emit('changeComment', this.comment)
      }
    }
  }
</script>

<style lang="scss" scoped>
.mk__area {
  margin-top: 30px;
}
</style>
